import React, { useState } from 'react';
import './index.scss';
import { formatDelta, HEADER_TEXT } from './constants';
import DumbellChart from './children/DumbbellChart';
import QuadrantChart from './children/QuadrantChart';
import SectionHeader from '../../../../../SectionHeader';
import { getScaleConfig } from '../../../../../../utils/scaleConfig';

const VIEWS = [
    { id: 'dumbbell', label: 'Dumbbell' },
    { id: 'quadrant', label: 'Quadrant' },
];

const Divergence = (props) => {
    const [view, setView] = useState('dumbbell');
    const scale = getScaleConfig(props.scaleType);
    let divergenceData = props.fetchSelfVsOthersApi.data && props.fetchSelfVsOthersApi.data.data ? props.fetchSelfVsOthersApi.data.data : []
    return (
        <>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />


        <div className='cardwrapper'>
            <div className='divergence'>
                {/* Toolbar: caption on the left, Dumbbell/Quadrant view toggle on the right */}
                <div className='divergence__toolbar'>
                    <span className='divergence__subtitle'>
                        Self vs. All But Self across categories. Favorable zone starts at{' '}
                        <strong>{scale.favorableThreshold}</strong>.
                    </span>
                    <div className='divergence__viewtoggle' role='tablist' aria-label='Chart view'>
                        {VIEWS.map((v) => (
                            <button
                                key={v.id}
                                type='button'
                                role='tab'
                                aria-selected={view === v.id}
                                className={`divergence__viewtoggle-btn${view === v.id ? ' is-active' : ''}`}
                                onClick={() => setView(v.id)}
                            >
                                {v.label}
                            </button>
                        ))}
                    </div>
                </div>

                {view === 'dumbbell' ? (
                    // Screen-only horizontal scroll on narrow viewports (the grid has a
                    // fixed min-width); the wrapper is inert in print (@media screen in scss).
                    <div className='divergence__scroll'>
                            <DumbellChart divergenceData={divergenceData} scale={scale} />
                    </div>
                ) : (
                        <div className='divergence__quadrant'>
                            <div className='divergence__quadrant-top'>
                                <div className='divergence__quadrant-chart'>
                                        <QuadrantChart divergenceData={divergenceData} scale={scale} />
                                </div>
                                <div className='divergence__howto'>
                                    <div className='divergence__howto-title'>How to read</div>
                                    <div className='divergence__howto-desc'>
                                        Points above the dashed diagonal mean Self rates higher than
                                        stakeholders (over-rating); points below mean the reverse
                                        (under-rating). The shaded upper-right block is the favorable zone
                                        for both.
                                    </div>
                                    <div className='divergence__quadrant-list'>
                                            {[...divergenceData]
                                            .sort((a, b) => Math.abs(b.self - b.others) - Math.abs(a.self - a.others))
                                            .map((row) => {
                                                const gap = row.self - row.others;
                                                return (
                                                    <div className='divergence__ql-row' key={row.category}>
                                                        <span
                                                            className='divergence__ql-dot'
                                                            style={{ background: gap > 0 ? 'var(--dv-self)' : 'var(--dv-others)' }}
                                                        />
                                                        <span className='divergence__ql-name'>{row.category}</span>
                                                        <span className='divergence__ql-delta'>{formatDelta(gap)}</span>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>

                            {/* Footer: legend + the coaching-threshold note */}
                            <div className='divergence__footer'>
                                <div className='divergence__legend'>
                                    <span className='divergence__legend-item'>
                                        <span className='divergence__dot divergence__dot--self' />
                                        Self
                                    </span>
                                    <span className='divergence__legend-item'>
                                        <span className='divergence__dot divergence__dot--others' />
                                        All But Self
                                    </span>
                                </div>
                                <span className='divergence__note'>
                                    Gaps of 0.30 or more typically warrant a coaching conversation.
                                </span>
                            </div>
                        </div>
                )}
            </div>
        </div>
        </>
    );
};

export default Divergence;
